import Axios from "axios";
import axios from "axios";

// const ADV_BASE_URL =
//   "https://cors-anywhere.herokuapp.com/http://am-research-api.eba-zcep6zj5.ap-south-1.elasticbeanstalk.com/";

const ADV_BASE_URL =
  "https://gatewayapi-uat.invest19.com";

 
const BASE_URL = 
  "https://gatewayapi-uat.invest19.com";
const FIND_LIST = "/api/get/all?filter=Upcoming,Ongoing,Closed";




const SAVE_SCRIP = "research/save/scrip";
const SEARCH_SCRIP = "find/symbol";
const SELECT_CATEGORY_LIST = "research/find/scrip/categories";
const LOGIN_END_POINT = "/user/auth/performance/login";
const MODIFY_SCRIP = "research/modify/scrip";
const CALL_TYPE = "find/category";
const EXCHANGE = "find/exchange";
const MARKET = "find/market";
const INSTRUMENT_TYPE = "find/instrument";
const EXPIRY_DATE = "find/expiryDate";
const STRIKE_PRICE = "find/strikePrice";
const OPTION_TYPE = "find/optionType";
const CATEGORY_LIST = "find/categoriesList";
const TARGET_PRICE = "find/targetprice";
const STOP_LOSS_PRICE = "find/stoploss";
const ADD_CALL = "save/callDetails";
const SIGNUP = "save/admin/signupdetails";
const ADMIN_DETAIL = "find/admindetails";
const FUND_WITHDRAWAL = "store/admin/withdrawal/amount";

const token = localStorage.getItem('auth_token');
Axios.defaults.headers.common['Authorization'] = `Bearer ${token} ' '`;

// super admin end points

const SEARCH_LIST = "/user/search";
const GENERATE_CODE = "/referrals/generate/code";

// broker list
const ALL_BROKER_LIST = "/broker/get/list";
const ALL_BROKER_EDIT = "/broker/edit/broker";


//guest list trade
const ALL_GUEST_LIST = "/performance/get/all/orders/details/between/dates?page_from=0&page_to=100000";

//guest list trade staus
const ALL_GUEST_LIST_STATUS = "/performance/get/all/orders/total/details?page_from=0&page_to=100000";



//guest list trade
const ALL_GUEST_LIST_IPO = "/performance/get/all/ipo/details/between/dates?page_from=0&page_to=100000";



// const ALL_BROKER_DELETE = "/broker/get/list";
// broker list
class ApiService {
  
  searchList(data) {
    return axios.post(ADV_BASE_URL + SEARCH_LIST, data);
  }

  generateCode(data) {
    return axios.post(BASE_URL + GENERATE_CODE, data);
  }
  

// broker list
  allBrokerList() {
    return axios.get(BASE_URL + ALL_BROKER_LIST);
  }
  AllBrokerEdit(data) {
    return axios.put(BASE_URL + ALL_BROKER_EDIT, data);
  }
// broker list
// Guest List
// allGuestList(fromDate, toDate) {
//   // debugger;
//   // console.log(localStorage.getItem("auth_token"),"Token in api call");
//   const token = localStorage.getItem('auth_token');
//   return axios.get(BASE_URL + ALL_GUEST_LIST + '&localDateFrom=' + (fromDate ? fromDate : '') + '&localDateTo=' + (toDate ? toDate : ''), { headers: {Authorization : `Bearer ${token}`}} );
// }
//

// Guest List Trade
allGuestList(fromDate, toDate) {
  return axios.get(BASE_URL + ALL_GUEST_LIST + '&date_from=' + (fromDate ? fromDate : '') + '&date_to=' + (toDate ? toDate : ''), { headers: {Authorization : `Bearer ${token}`}} );
}
// Guest List Trade

// Trade status
allGuestListStatus(fromDate, toDate) {
  return axios.get(BASE_URL + ALL_GUEST_LIST_STATUS + '&date_from=' + (fromDate ? fromDate : '') + '&date_to=' + (toDate ? toDate : ''), { headers: {Authorization : `Bearer ${token}`}});
}
// Guest List Trade status




// Guest List IPO
allGuestListipo(fromDate, toDate) {
  return axios.get(BASE_URL + ALL_GUEST_LIST_IPO + '&date_from=' + (fromDate ? fromDate : '') + '&date_to=' + (toDate ? toDate : ''), { headers: {Authorization : `Bearer ${token}`}});
}
// Guest List IPO


  fetchAllData() {
    return axios.get(BASE_URL + ADMIN_DETAIL);
  }

  signUp(data) {
    return axios.post(ADV_BASE_URL + SIGNUP, data);
  }

  

  fetchCallType() {
    return axios.get(ADV_BASE_URL + CALL_TYPE);
  }

  fetchExchange() {
    return axios.get(ADV_BASE_URL + EXCHANGE);
  }

  fetchMarket() {
    return axios.get(ADV_BASE_URL + MARKET);
  }

  fetchInst(data) {
    return axios.post(ADV_BASE_URL + INSTRUMENT_TYPE, data);
  }

  fetchExpDate(data) {
    return axios.post(ADV_BASE_URL + EXPIRY_DATE, data);
  }

  fetchOptionType(data) {
    return axios.post(ADV_BASE_URL + OPTION_TYPE, data);
  }

  fetchTargetPrice(data) {
    return axios.post(ADV_BASE_URL + TARGET_PRICE, data);
  }

  fetchStrikePrice(data) {
    return axios.post(ADV_BASE_URL + STRIKE_PRICE, data);
  }

  fetchStopLossPrice(data) {
    return axios.post(ADV_BASE_URL + STOP_LOSS_PRICE, data);
  }

  addCall(data) {
    return axios.post(ADV_BASE_URL + ADD_CALL, data);
  }

  fetchCategoriesList(data) {
    return axios.post(ADV_BASE_URL + CATEGORY_LIST, data);
  }

  researchLogin(values) {
    return axios.post(
      `${ADV_BASE_URL}${LOGIN_END_POINT}?adminId=${values.adminId}&adminPassword=${values.adminPassword}`
    );
  }

  modifyScripData(data) {
    return axios.put(ADV_BASE_URL + MODIFY_SCRIP, data);
  }
  closeScripData(data) {
    return axios.put(ADV_BASE_URL + MODIFY_SCRIP, data);
  }

  publishScripData(data) {
    return axios.put(ADV_BASE_URL + MODIFY_SCRIP, data);
  }

  saveScripData(saveScrip) {
    return axios.post(ADV_BASE_URL + SAVE_SCRIP, saveScrip);
  }

  searchScripDataList(searchScrip) {
    return axios.post(ADV_BASE_URL + SEARCH_SCRIP, searchScrip);
  }
  categoryDataList(categoryList) {
    return axios.post(ADV_BASE_URL + SELECT_CATEGORY_LIST, categoryList);
  }
  findAdminDetail(data) {
    return axios.post(ADV_BASE_URL + ADMIN_DETAIL, data);
  }
  fundWithdrawalAmount(data) {
    return axios.post(ADV_BASE_URL + FUND_WITHDRAWAL, data);
  }
}

export default new ApiService();
